import axios from 'axios';
// import {
//     closeLoading
// } from "@/utils/loading"
// import store from '@/store'
import router from '@/router'
import {
    Message,
    MessageBox
} from 'element-ui'
const CONFIG = {
    baseURL: base_url,
    timeout: 10 * 60 * 1000,
};

// 创建axios实例
const service = axios.create(CONFIG);


/*
发送请求时添加:
headers:
token:用户凭证
*/
service.interceptors.request.use(config => {
    // console.log(window.localStorage.token)
    // 在发送请求之前做些什么
    //判断是否存在token，如果存在将每个页面header都添加token
    if (window.localStorage.token) {
        //config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
        config.headers.common['token'] = window.localStorage.token
       
        config.headers.common['Access-Control-Allow-Origin']= '*'
       
        // config.headers.common['Content-Type'] ="application/x-www-form-urlencoded"
        // config.headers.common['Content-Type'] = 'multipart/form-data';
    }

    //   config.headers['Content-Type'] ="application/x-www-form-urlencoded"

    return config;
}, error => {
    //console.log(error)
    return Promise.reject(error);
})

/*http response 拦截器
1：拦截返回的token，更新本地token
2：拦截返回信息，超时给出提示重新登陆。
*/ 
service.interceptors.response.use(
    response => {
        console.log(response)
        // if (response.data.status != 0) {

        //     Message({
        //         message: response,
        //         type: 'error',
        //         duration: 3 * 1000
        //     })

        //     Message({
        //         message: response.data.message ? response.data.message : response.data.data,
        //         type: 'error',
        //         duration: 3 * 1000
        //     })
        //     return Promise.reject(response.data.data)
        // }


        // if (!response.data) {
        //     Message({
        //         message: '系统发生错误,请联系管理员！',
        //         type: 'error',
        //         duration: 3 * 1000
        //     })
        //     return Promise.reject('系统发生错误,请联系管理员！')
        // }
        // // 返回错误信息
        // if (response.data.status === -1) {
        //     Message({
        //         message: response.data.data,
        //         type: 'error',
        //         duration: 3 * 1000
        //     })
        //     return Promise.reject('系统发生错误,请联系管理员！')
        // }
        // // token 超时
        // if (response.data.status == -5003) {
        //     closeLoading()
        //     //alert(i18n.t("ResourceDictionary.LoginTimeOut"))
        //     store.commit('LoginOut')
        //     router.replace({
        //         path: '/login'
        //         //query: { redirect: router.currentRoute.fullPath }//登录成功后跳入浏览的当前页面
        //     })
        //     return Promise.reject('系统发生错误,请联系管理员！')
        // }

        return response.data
    },
    error => {
        return Promise.reject(error.message)
    })

export default service


// WEBPACK FOOTER //
// ./src/http/request.js